import { BillingBookingComponent } from "~/components/admin/billing";
import {
  Booking,
  ServiceForInvoice,
  StorageCalculation,
} from "~/components/admin/billing/types";

const sampleBooking: Booking = {
  bookingReference: "BOOK-123",
  createdAt: new Date().toISOString(),
  client: {
    companyName: "Sample Client",
    quickBooksId: "QB-123",
    travelTime: 1,
  },
  location: {
    name: "New York Warehouse",
  },
};

const sampleServices: ServiceForInvoice[] = [
  {
    id: "1",
    serviceType: "COLLECTION",
    serviceReference: "COLL-001",
    serviceDate: "2025-06-18",
    duration: 2,
    startTime: "2025-06-18T09:00:00Z",
    endTime: "2025-06-18T11:00:00Z",
    totalHours: 2,
    clientId: "CL-001",
    clientName: "Sample Client",
    location: "New York Warehouse",
    vesselId: "V-001",
    vesselName: "Truck A",
    vesselRate: 50,
    staffIds: ["S-001", "S-002"],
    staffNames: ["John", "Jane"],
    staffRates: [20, 25],
    inventoryIds: ["I-001"],
    inventoryCubicFootage: 100,
    suppliesUsed: [
      {
        id: "SUP-001",
        name: "Packing Tape",
        quantity: 2,
        cost: 5,
        price: 10,
        selected: true,
      },
    ],
    adminFees: [
      { id: "FEE-001", name: "Handling Fee", amount: 30, selected: true },
    ],
    travelTime: 1,
    minimumHours: 4,
    selected: false,
    invoiceStatus: "not_invoiced",
  },
];

const sampleStorageDates: StorageCalculation[] = [
  { date: "2025-06-13", cubicFootage: 200 },
  { date: "2025-06-14", cubicFootage: 200 },
];

export const ScreenBooking = () => {
  return (
    <BillingBookingComponent
      booking={sampleBooking}
      services={sampleServices}
      storageDates={sampleStorageDates}
      averageStorage={200}
      totalInventoryValue={10000}
      setServices={() => {}}
    />
  );
};
